import React from 'react';
import PropTypes from 'prop-types';
import {
  CompositeCard,
  BaseCardItem,
  dates,
} from '@unite-us/app-components';
import _ from 'lodash';
import { isCaseOpen } from 'src/components/Cases/utils';
import ServiceType from 'src/components/Group/Programs/components/ServiceType';

function CaseSummary(props) {
  const { contactCases } = props;
  const activeCases = _.filter(contactCases, (x) => isCaseOpen(x));

  if (_.isEmpty(activeCases)) {
    return null;
  }

  return (
    <CompositeCard title="Open Cases" className="case-summary" id="facesheet-case-summary">
      {activeCases.map((serviceCase) => {
        const formattedDate = serviceCase.opened_date ?
          dates.formatDate(serviceCase.opened_date) :
          dates.formatDate(serviceCase.created_at);

        return (
          <BaseCardItem
            key={serviceCase.id}
            variant="compact"
            icon={<ServiceType service={_.get(serviceCase, 'service')} iconOnly />}
            title={serviceCase.service?.name || serviceCase.name}
            metadata={{
              programName: _.get(serviceCase, 'program.name'),
              providerName: serviceCase.provider?.name,
              dateOpened: formattedDate,
            }}
            id={`case-${serviceCase.id}`}
          />
        );
      })}
    </CompositeCard>
  );
}

CaseSummary.propTypes = {
  contactCases: PropTypes.array,
};

CaseSummary.defaultProps = {
  contactCases: [],
};

export default CaseSummary;
